import { Button, Col, Form, Input, message, Row, Icon, AutoComplete, Checkbox } from 'antd';
import React from 'react';
import moment from 'moment';
import { getSwjg, adm, alxd } from './VerifyInvoice';
import { invoiceImport, invoiceInput } from 'src/api';
import BaseImport, { IProps, create } from './BaseImport';
import debounce from 'lodash/debounce';
const FormItem = Form.Item;
const Option = AutoComplete.Option;
@create()

class Component extends BaseImport<IProps, any> {
    public form: any;
    private input1: Input;
    private input2: Input;
    private input3: Input;
    private input4: Input;
    private input5: Input;
    constructor(props: IProps) {
        super(props);
        this.state = {
            value: '',
            loading: false,
            showCheck: false,
            tip: '开具金额(不含税)',
            url: this.props.url && this.props.url.key4,
            inputType: this.props.url.key4inputType,
            available: false,
            showFive: this.props.url.show || false,
            upload: true,
            list: [],
            draftFlag: 1,
            showdeduction: this.props.url.deduction || false,
        };
        this.fetchGroup = debounce(this.fetchGroup, 800);
    }
    handleSubmit = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                if (!this.state.upload) {
                    message.warn('发票组不存在');
                    return false;
                }
                const companyId = sessionStorage.getItem('companyId');
                const loggedUserId = sessionStorage.getItem('userId');
                const url = this.state.url;
                const { inputType, draftFlag } = this.state;
                let data = {
                    ...values,
                    companyId,
                    loggedUserId,
                    url,
                    inputType,
                    draftFlag
                };
                this.input1.input.select();
                if (typeof data.url === 'function') {
                    data.url(data).then(() => {
                        this.setState({ loading: false });
                    });
                } else {
                    invoiceImport.manualImport(this, data).then((response: any) => {
                        const err2 = response.er;
                        this.setState({ loading: false });
                        if (err2) {
                            return null;
                        } else {
                            this.success();
                        }
                    });

                }
                this.setState({ loading: true });
            }
        });
    }
    resetForm = () => {
        const { resetFields } = this.props.form;
        resetFields();
    }
    success = () => {
        message.success('录入成功');
        super.callback();
    }
    error = () => {
        message.error('录入失败');
    }
    onCodeChange = (rule, value, callback) => {
        //检测是否为全数字
        if (rule.pattern.test(value)) {
            if (value.length === 10 || value.length === 12) {
                let swjginfo = getSwjg(value, 0);
                if (swjginfo.length === 0) {
                    callback('发票代码有误!');
                } else {
                    if (!adm(value) || swjginfo.length === 0) {
                        callback('发票代码有误!');
                    } else {
                        let fplx = alxd(value);//fplx 发票类型 
                        // "01"纸专  "02"货运发票  "03"机动车  "04"普票  "08";增值税专票(电子)  "10"电子票  "11";卷票   "13"  "14";通行费  "15";二手车发票
                        if ((fplx === '01' || fplx === '02' || fplx === '03' || fplx === '08' || fplx === '15')) {
                            this.setState({
                                showCheck: false
                            });
                            if (fplx === '02') {
                                this.setState({
                                    tip: '合计金额'
                                });
                                callback('不支持货票录入');
                            } else if (fplx === '03') {
                                this.setState({
                                    tip: '不含税价'
                                });
                            } else if (fplx === '15') {
                                this.setState({
                                    tip: '车价合计'
                                });
                            } else {
                                this.setState({
                                    tip: '开具金额(不含税)'
                                });
                            }
                        } else if (fplx === '04' || fplx === '10' || fplx === '11' || fplx === '14') {
                            this.setState({
                                showCheck: true
                            });
                        }
                        if (fplx === '01' || fplx === '03' || fplx === '14') {
                            this.setState({
                                available: true
                            });
                        } else {
                            this.setState({
                                available: false
                            });
                        }
                        callback();
                    }
                }
            } else {
                callback('请输入10位或12位合法的发票代码');
            }
        } else {
            callback('发票代码只支持数字');
        }
    }
    onincreaseTabindex1 = (e) => {
        this.props.form.validateFieldsAndScroll(['invoiceCode'], (err, values) => {
            if (!err) {
                this.input2.focus();
                this.input2.input.select();
            }
        });
    }
    onincreaseTabindex2 = (e) => {

        this.props.form.validateFieldsAndScroll(['invoiceCode', 'invoiceNumber'], (err, values) => {
            if (!err) {
                this.input3.focus();
                this.input3.input.select();
                let data = {
                    invoiceCode: values.invoiceCode,
                    invoiceNumber: values.invoiceNumber
                };
                if (this.state.available && this.state.showFive) {
                    invoiceImport.invoiceFetch(this, data).then((response: any) => {
                        const err2 = response.err;
                        const res = response.res;
                        if (err2) {
                            message.error(err2.status.description);
                            return null;
                        } else {
                            if (res.invoiceDate) {
                                if (this.state.showCheck) {
                                    this.props.form.setFieldsValue({
                                        invoiceDate: moment.unix(res.invoiceDate / 1000).format('YYYYMMDD'),
                                        invoiceParityCode: res.invoiceParityCode && res.invoiceParityCode.substr(-6, 6),
                                    });
                                } else {
                                    this.props.form.setFieldsValue({
                                        invoiceDate: moment.unix(res.invoiceDate / 1000).format('YYYYMMDD'),
                                        amountWithoutTax: res.amountWithoutTax
                                    });
                                }
                            }
                        }
                    });
                }
            }
        });

    }
    onincreaseTabindex3 = (e) => {
        if (this.state.showCheck) {
            this.input4.focus();
            this.input4.input.select();
        } else {
            this.input5.focus();
            this.input5.input.select();
        }
    }
    onincreaseTabindex4 = (e) => {
        this.handleSubmit();
    }
    onAddGroup = () => {
        invoiceInput.CreatGroup(this, {}).then((response: any) => {
            const err2 = response.er;
            const res = response.res;
            if (err2) {
                message.error(err2.status.description);
                return null;
            } else {
                if (res) {
                    message.success('操作成功');
                    this.props.form.setFieldsValue({ groupNumber: res });
                }
            }
        });
    }
    fetchGroup = (value) => {
        const groupNumber = value;
        if (groupNumber) {
            invoiceInput.GetGroupList(this, { groupNumber }).then((response: any) => {
                const err = response.er;
                const res = response.res;
                if (err) {
                    return null;
                } else {
                    if (res) {
                        this.setState({
                            list: res
                        });
                    }
                }
            });
        }
    }
    checkDate = (rule, value, callback) => {
        if (rule.pattern.test(value)) {
            let isValid = moment(value).isValid();
            if (isValid) {
                callback();
            } else {
                callback('格式不对');
            }
        } else {
            callback('格式不对');
        }
    }
    onChange = (e) => {
        if (e.target.checked) {
            this.setState({
                draftFlag: 1
            });
        } else {
            this.setState({
                draftFlag: 0
            });
        }
    }
    render() {
        let formItemLayout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 }
        };
        const { getFieldDecorator } = this.props.form;
        const config = {
            rules: [{
                type: 'string',
                required: true,
                message: '日期格式(20170203)',
                validator: this.checkDate,
                pattern: /\d{8}/
            }]
        };
        let colspan = 21;
        const options = this.state.list.map(d => <Option key={d.groupNumber}>{d.groupNumber}</Option>);
        return (
            <Form className="manual-write-style special" ref={(e) => this.form = e}>
                <Row>
                    <Col span={colspan}>
                        <FormItem {...formItemLayout} label="发票代码" hasFeedback={true}>
                            {getFieldDecorator('invoiceCode', {
                                rules: [
                                    {
                                        required: true,
                                        pattern: /^[0-9]*$/,
                                        validator: this.onCodeChange
                                    }
                                ]
                            })(
                                <Input ref={(input) => { this.input1 = input; }} placeholder="10位或12位发票码" maxLength={12} onPressEnter={this.onincreaseTabindex1} />
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span={colspan}>
                        <FormItem {...formItemLayout} label="发票号码">
                            {getFieldDecorator('invoiceNumber', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入8位发票号码（只支持数字)',
                                        pattern: /^\d{8}$/
                                    }
                                ]
                            })(<Input ref={(input) => { this.input2 = input; }} placeholder="8位发票号码" maxLength={8} onPressEnter={this.onincreaseTabindex2} />)}
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span={colspan}>
                        <FormItem {...formItemLayout} label="开票日期">
                            {getFieldDecorator('invoiceDate', config)(
                                <Input ref={(input) => { this.input3 = input; }} maxLength={8} placeholder="日期格式(20170203)" onPressEnter={this.onincreaseTabindex3} />
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span={colspan}>
                        {!this.state.showCheck && (
                            <FormItem {...formItemLayout} label={this.state.tip}>
                                {getFieldDecorator('amountWithoutTax', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入金额（小数点最多输入两位,最大长度12位数包括小数)',
                                            pattern: /(^-?[1-9](\d+)?(\.\d{1,2})?$)|(^-?0$)|(^-?\d\.\d{1,2}$)/
                                        }
                                    ]
                                })(
                                    <Input ref={(input) => { this.input5 = input; }} style={{ width: '100%' }} type="number" maxLength={12} onPressEnter={this.onincreaseTabindex4} />
                                )}
                            </FormItem>
                        )}

                        {this.state.showCheck && (
                            <FormItem {...formItemLayout} label="校验码">
                                {getFieldDecorator('invoiceParityCode', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入6位校验码（只支持数字)',
                                            pattern: /^\d{6}$/
                                        }
                                    ]
                                })(
                                    <Input ref={(input) => { this.input4 = input; }} placeholder="发票校验码后6位" maxLength={6} onPressEnter={this.onincreaseTabindex4} />
                                )}
                            </FormItem>
                        )}
                    </Col>
                </Row>
                {
                    this.state.showFive &&
                    <Row>
                        <Col span={colspan} >
                            <FormItem {...formItemLayout} label="指定到发票组">
                                {getFieldDecorator('groupNumber', {
                                    rules: [{ message: '请输入编号(最大长度36位)', max: 36 }]
                                })(
                                    <AutoComplete
                                        onSearch={this.fetchGroup}
                                    >
                                        {options}
                                    </AutoComplete>
                                )}
                            </FormItem>
                        </Col>
                        <Col span={2} offset={1}>
                            <span style={{ lineHeight: '39px' }} className="hand" onClick={this.onAddGroup}><Icon type="plus" /></span>
                        </Col>
                    </Row>
                }

                <Row>
                    <Col span={colspan}>
                        <FormItem className="text-center">
                            <Button type="primary" onClick={this.handleSubmit} loading={this.state.loading}>
                                确认保存
                            </Button>
                        </FormItem>
                    </Col>
                </Row>
                {
                    this.state.showdeduction &&
                    <Row>
                        <Col span={colspan}>
                            <FormItem {...formItemLayout} >
                                {getFieldDecorator('draftFlag', {
                                    valuePropName: 'checked',
                                    initialValue: !!this.state.draftFlag
                                })(
                                    <Checkbox onChange={this.onChange} >录入时勾选发票</Checkbox>
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                }
            </Form>
        );
    }
}
const ManualImport = Form.create()(Component);
export default ManualImport;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/part/InvoiceImport/InvoiceTab/AdvanceManualImport.tsx